import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import QuestionReview from "../../components/QuestionReview";

export default function Bookmarks() {
  const [qs, setQs] = useState([]);
  useEffect(() => { api.get("/student/bookmarks").then((r) => setQs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Bookmarked Questions</h1>
      {qs.length === 0 ? <div className="card-surface p-8 text-center text-content-muted">No bookmarks yet. Bookmark questions from the result page.</div>
        : <div className="space-y-4">{qs.map((q) => <QuestionReview key={q.id} q={q} />)}</div>}
    </div>
  );
}
